module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-05.9bd8ba5c.png";